import { AxiosResponse } from "axios";
import { apiInstance } from "../base";
import { IDadataPartyQuery, IDadataPartyResponse } from "./types";

export const getPartyByInn = (
  query: IDadataPartyQuery
): Promise<AxiosResponse<IDadataPartyResponse[]>> => {
  return apiInstance.handler.get<IDadataPartyResponse[]>("/dadata/party", {
    params: {
      inn: query.inn,
      count: query.count,
    },
  });
};

